import { render, staticRenderFns } from "./InsFun.vue?vue&type=template&id=5afa114a&scoped=true"
import script from "./InsFun.vue?vue&type=script&lang=ts"
export * from "./InsFun.vue?vue&type=script&lang=ts"
import style0 from "./InsFun.vue?vue&type=style&index=0&id=5afa114a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa114a",
  null
  
)

export default component.exports